document.addEventListener('DOMContentLoaded', function () {
  function initCollectionModeSwitcher() {
    var MOBILE_WIDTH = 750;
    var gridBtn, listBtn, productGrid;
    var lastIsMobile = null;

    function getEls() {
      gridBtn = document.getElementById('grid-mode');
      listBtn = document.getElementById('list-mode');
      productGrid = document.getElementById('product-grid');
    }

    function clearSwitcherListeners() {
      if (gridBtn) {
        var newGridBtn = gridBtn.cloneNode(true);
        gridBtn.parentNode.replaceChild(newGridBtn, gridBtn);
        gridBtn = newGridBtn;
      }
      if (listBtn) {
        var newListBtn = listBtn.cloneNode(true);
        listBtn.parentNode.replaceChild(newListBtn, listBtn);
        listBtn = newListBtn;
      }
    }

    function setMobileView() {
      getEls();
      if (!gridBtn || !listBtn || !productGrid) return;
      // Restore state
      var view = localStorage.getItem('collectionViewMode');
      if (!view) {
        if (productGrid.classList.contains('collection-product-list--2-mobile')) {
          view = 'grid';
        } else {
          view = 'list';
        }
      }
      if (view === 'grid') {
        productGrid.classList.remove('collection-product-list--1-mobile');
        productGrid.classList.add('collection-product-list--2-mobile');
        gridBtn.classList.add('active');
        listBtn.classList.remove('active');
      } else {
        productGrid.classList.remove('collection-product-list--2-mobile');
        productGrid.classList.add('collection-product-list--1-mobile');
        listBtn.classList.add('active');
        gridBtn.classList.remove('active');
      }
      localStorage.setItem('collectionViewMode', view);
      // Save state on click
      gridBtn.addEventListener('click', function () {
        productGrid.classList.remove('collection-product-list--1-mobile');
        productGrid.classList.add('collection-product-list--2-mobile');
        localStorage.setItem('collectionViewMode', 'grid');
        gridBtn.classList.add('active');
        listBtn.classList.remove('active');
      });
      listBtn.addEventListener('click', function () {
        productGrid.classList.remove('collection-product-list--2-mobile');
        productGrid.classList.add('collection-product-list--1-mobile');
        localStorage.setItem('collectionViewMode', 'list');
        listBtn.classList.add('active');
        gridBtn.classList.remove('active');
      });
    }

    function setDesktopView() {
      getEls();
      if (!productGrid) return;
      productGrid.classList.remove('collection-product-list--2-mobile');
      productGrid.classList.add('collection-product-list--1-mobile');
      if (gridBtn) gridBtn.classList.remove('active');
      if (listBtn) listBtn.classList.remove('active');
    }

    function handleResize() {
      var isMobile = window.innerWidth < MOBILE_WIDTH;
      if (isMobile === lastIsMobile) return;
      lastIsMobile = isMobile;
      clearSwitcherListeners();
      if (isMobile) {
        setMobileView();
      } else {
        setDesktopView();
      }
    }

    lastIsMobile = window.innerWidth < MOBILE_WIDTH;
    if (lastIsMobile) {
      setMobileView();
    } else {
      setDesktopView();
    }
    window.addEventListener('resize', handleResize);
  }

  initCollectionModeSwitcher();

  document.addEventListener('pagination:updated', function () {
    // Re-initialize the collection mode switcher after AJAX updates
    initCollectionModeSwitcher();
  });
});
